import { inject, Injectable, signal } from '@angular/core';
import { ISearchCombinedDTO } from '../../../models/ISearchCombinedDTO';
import { CommonHttpService } from '../../common-http.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, finalize, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ISearchOnlyItemsResponse } from '../../../models/ISearchOnlyItemsResponse';
import { IAuctionListing } from '../../../models/IAuctionListing';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor() { }

  searchCombinedSignal = signal<ISearchCombinedDTO | null>(null);
  itemsResultSignal = signal<ISearchOnlyItemsResponse | null>(null);
  auctionsResultSignal = signal<IAuctionListing[]>([]);

  isLoading = signal<boolean>(false);
  isLoadingItems = signal<boolean>(false);

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);

  public getSearchResult(query: string): Observable<ISearchCombinedDTO> {

    let url = `${environment.apiUrl}/v3/bidder-community/search/combined`;


    let params = new URLSearchParams();
    if (query) params.append('query', query);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    this.isLoading.set(true);

    // console.log('url', url);


    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders().set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.httpService.get<ISearchCombinedDTO>(url, undefined, headers);
        }
        return this.httpService.get<ISearchCombinedDTO>(url);
      }),
      tap(response => {
        this.searchCombinedSignal.set(response);
      }),
      finalize(() => this.isLoading.set(false))
    );
  }

  public getItemsResult(query: string, page?: number, per?: number, sort?: string): Observable<ISearchOnlyItemsResponse> {

    let url = `${environment.apiUrl}/v3/bidder-community/search/items`;

    let params = new URLSearchParams();
    if (query) params.append('query', query);
    if (page) params.append('page', page.toString());
    if (per) params.append('per', per.toString());
    if (sort) params.append('sort', sort.toString());

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    this.isLoadingItems.set(true);
    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<ISearchOnlyItemsResponse>(url, undefined, headers);
        } else {
          return this.httpService.get<ISearchOnlyItemsResponse>(url);
        }
      }),
      tap(response => {
        this.itemsResultSignal.set(response);
        this.isLoadingItems.set(false);
        // console.log('response items', response)
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    )
  }

  public getAuctionResult(query: string): Observable<IAuctionListing[]> {

    let url = `${environment.apiUrl}/v3/bidder-community/search/auctions`;

    let params = new URLSearchParams();
    if (query) params.append('query', query);
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<IAuctionListing[]>(url, undefined, headers);
        } else {
          return this.httpService.get<IAuctionListing[]>(url);
        }
      }),
      tap(response => {
        this.auctionsResultSignal.set(response);
        // console.log('response auctions', response)
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    )
  }



}
